import { COLORS } from "./COLORS";
import {
    AccountBalanceIcon,
    AssessmentIcon,
    bannerImage1, bannerImage2, bannerImage3,
    BarChartIcon,
    BusinessIcon,
    Email,
    Facebook,
    icon1, icon2, icon3,
    Instagram,
    LocationOn,
    Phone,
    SupportAgentIcon,
    teamImage1, teamImage2, teamImage3,
    TrendingUpIcon,
    XIcon
} from "./images";
//heading Text
export const aboutHeading="About Us";
export const aboutSubHeading="  Experience and Expertise: Our Financial Consulting Team";
export const contactHeadingText = "Get in Touch";
export const contactSubHeadingText = "We are here for you! How can we help?"
export const teamHeadingText = "Our Team";


//button Text
export const contactButtonText = "Submit";
export const footerButtonText = "Send";


//navigation bar Data
export const navigationData = ["Home", "About", "Service", "Team", "Contact"];

//banner data
export const bannerImages = [bannerImage1, bannerImage2, bannerImage3];
export const bannerData = [
    "VISION INTO REALITY",
    "Expert Guidance For Your Financial Future",
    "SMART FINANCIAL STRATEGIES"
];

//about data

export const aboutData = [
    { title: "Market Research", description: "Analyzing market trends to identify opportunities.", icon: <TrendingUpIcon sx={{ fontSize: 60, color: COLORS.secondaryColor }} /> },
    { title: "Data Analytics", description: "Transforming raw data into actionable insights.", icon: <BarChartIcon sx={{ fontSize: 60, color: COLORS.secondaryColor }} /> },
    { title: "Investment Strategies", description: "Developing risk-managed investment plans.", icon: <AccountBalanceIcon sx={{ fontSize: 60, color: COLORS.secondaryColor }} /> },
    { title: "Performance Evaluation", description: "Assessing financial health and operational efficiency.", icon: <AssessmentIcon sx={{ fontSize: 60, color: COLORS.secondaryColor }} /> },
    { title: "Customer Support", description: "Ensuring excellent client relations and service experience.", icon: <SupportAgentIcon sx={{ fontSize: 60, color: COLORS.secondaryColor }} /> },
    { title: "Business Development", description: "Strategizing for company growth and expansion.", icon: <BusinessIcon sx={{ fontSize: 60, color: COLORS.secondaryColor }} /> },
];

  // service information
export const services = [
    {
        icon: icon1,
        title: "On Time Service",
        description:
            "There are many variations of passages of Lorem the Ipsum available, but the majority have suffered of alteration in some form, by injected.",
    },
    {
        icon: icon2,
        title: "Team of Professionals",
        description:
            "There are many variations of passages of Lorem the Ipsum available, but the majority have suffered of alteration in some form, by injected.",
    },
    {
        icon: icon3,
        title: "Analyze Your Business",
        description:
            "There are many variations of passages of Lorem the Ipsum available, but the majority have suffered of alteration in some form, by injected.",
    },
];

// team data
export const teamMembers = [
    {
        id: 1,
        name: "Alice Johnson",
        role: "Frontend Developer",
        image: teamImage1,
        phoneNumber: "+972-526980001"
    },
    {
        id: 2,
        name: "Bob Williams",
        role: "Backend Developer",
        image: teamImage2,
        phoneNumber: "+972-526980002"
    },
    {
        id: 3,
        name: "Charlie Brown",
        role: "UI/UX Designer",
        image: teamImage3,
        phoneNumber: "+972-526980003"
    },
    {
        id: 4,
        name: "David Smith",
        role: "Project Manager",
        image: teamImage1,
        phoneNumber: "+972-526980004"
    },

];
//footer data
export const mediaData = [
    { Icon: Facebook, link: "https://www.facebook.com" },
    { Icon: XIcon, link: "https://www.twitter.com" },
    { Icon: Instagram, link: "https://www.instagram.com" },
];

// contact form data
export const contactDetails = [
    {
        icon: <LocationOn color={COLORS.secondaryColor}  />,
        title: "Address",
        detail: "2118, Syracuse, Connecticut 35624"
    },
    {
        icon: <Email color={COLORS.secondaryColor}  />,
        title: "Mail Us",
        detail: "tanya.hill@example.com"
    },
    {
        icon: <Phone color={COLORS.secondaryColor}  />,
        title: "Telephone",
        detail: "(704) 555-0127"
    }
];



export const formFields = [
  { id: "title", label: "Title", type: "select", options: ["Mr.", "Miss.", "Mrs.", "Dr."], defaultValue: "Mr.", row: "name", flex: 1 },
  { id: "firstName", label: "First Name", type: "text", placeholder: "First Name", row: "name", flex: 2 },
  { id: "lastName", label: "Last Name", type: "text", placeholder: "Last Name", row: "name", flex: 2 },
  { id: "mobile", label: "Mobile", type: "tel", placeholder: "Mobile", row: "mobile" },
  { id: "altMobile", label: "Alternate Mobile", type: "tel", placeholder: "Phone Number", required: false, row: "mobile" },
  { id: "email", label: "Email Address", type: "email", placeholder: "Email Address" },
  { id: "company", label: "Company Name", type: "text", placeholder: "Company Name" },
  { id: "communication", label: "Preferred Communication Method", type: "checkboxGroup", options: ["Email", "Call", "WhatsApp", "SMS"] },
  { id: "consent", label: "I consent to receive communications and agree to the terms", type: "checkbox" },
];



export const googleMapLink = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.473830707999!2d28.041218800000003!3d-26.1486937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9573c1da706ef5%3A0x9202607f9dc6f18!2sBig%20Five%20CRM%20Technologies%20(Pty)%20Ltd!5e0!3m2!1sen!2sin!4v1747914566030!5m2!1sen!2sin"

//footer data


export const COMPANY_INFO = {
    phoneHeading:" 24/7 CALL US",
    phone: "+(528) 456-7592",
    addressHeading:" 24/7 Our Location",
    address: "132, Tic St, Kingston, New York 12401, USA",
    newsletterMessage:
    "Welcome to Finxpert! Signup for our latest news & articles. We won’t send spam or irrelevant messages.",
};

export const SOCIAL_LINKS = [
    { href: "https://www.facebook.com", icon: "Facebook", label: "Facebook" },
    { href: "https://www.linkedin.com", icon: "LinkedIn", label: "LinkedIn" },
    { href: "https://www.twitter.com", icon: "XIcon", label: "Twitter" },
    { href: "https://www.instagram.com", icon: "Instagram", label: "Instagram" },
];

export const footerData=`Privacy Policy | Terms & Conditions | © ${new Date().getFullYear()} Company Name. All rights reserved.`